import styled from "styled-components";
import { media } from "@src/packages/chime-ui/system";

interface ContentProps {
  fullHeight?: boolean;
}

export const Content = styled.div<ContentProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${props =>
    props.fullHeight
      ? media.mobileOnly`
          min-height: 50vh;
        `
      : ""}
`;
